<template>
	<div class="row h-100" style="margin-left: 120px; margin-right: 120px;">
		<div class="col-6">
			<div class="d-flex justify-content-center h-100">
				<img class="d-block img-fluid m-auto" style="max-height: 750px;" :src="url" loading="lazy" />
			</div>
		</div>
		<div class="col-6">
			<h1 v-if="display_title" class="image-title">{{ title }}</h1>
			<div class="scroll-container" id="testaapje">
				<h1 class="image-description">{{ description }}</h1>
			</div>
		</div>
	</div>
</template>

<script>
import "overlayscrollbars/js/OverlayScrollbars.min.js";
export default {
	name: "GalleryLayout2",
	props: {
		title: String,
		display_title: Boolean,
		url: String,
		description: String,
	},
	mounted() {
		OverlayScrollbars(document.querySelectorAll("#testaapje"), {
			className: "os-theme-round-dark",
			scrollbars: {
				visibility: "auto",
			},
		});
	},
};
</script>

<style scoped>
.image-title {
	margin-top: 240px;
	text-align: center;

	color: #fff;
	font-size: 3.5em;
}
.image-description {
	text-align: left;
	color: #fff;
}

.scroll-container {
	margin-top: 40px;
	max-height: 500px;
	overflow: auto;
}

/* .scroll-container::-webkit-scrollbar-track {
	border-radius: 10px;
	border: 1px solid blue;
	width: 50px;
}
.scroll-container::-webkit-scrollbar {
	width: 50px;
	background-color: blue;
	border-radius: 10px;
}
.scroll-container::-webkit-scrollbar-thumb {
	border-radius: 100px;
	background-color: red;
	border: 5px solid blue;
	height: 50px;
	position: relative;
	height: 50px;
}

.scroll-container::-webkit-scrollbar-thumb::after {
	content: "";
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	background-color: yellow;
} */
</style>